import { Box } from "@mui/material";
import { ReactNode } from "react";

type AnimatedSectionProps = {
  children: ReactNode;
  /** Задержка появления в мс */
  delay?: number;
  /** Длительность анимации в мс */
  duration?: number;
  /** 'fadeUp' — появление снизу вверх с прозрачностью */
  variant?: "fadeUp";
};

/**
 * Секция с CSS-анимацией появления (без Intersection Observer).
 * Используется для hero и последовательного появления блоков при загрузке.
 */
export default function AnimatedSection({
  children,
  delay = 0,
  duration = 600,
  variant = "fadeUp",
}: AnimatedSectionProps) {
  return (
    <Box
      sx={{
        animation: `animFadeUp ${duration}ms cubic-bezier(0.4, 0, 0.2, 1) ${delay}ms both`,
        "@keyframes animFadeUp": {
          "0%": { opacity: 0, transform: "translateY(24px)" },
          "100%": { opacity: 1, transform: "translateY(0)" },
        },
      }}
    >
      {children}
    </Box>
  );
}
